
// import React, { useState, useEffect, useRef } from 'react';
// import './Header.css';
// import { useNavigate } from 'react-router-dom';
// import { MdPerson } from 'react-icons/md';
// import { FaUserCircle } from 'react-icons/fa';
// import { FiLogOut } from 'react-icons/fi';
// import { LuDatabaseBackup } from "react-icons/lu";
// import { HiBellAlert } from "react-icons/hi2"; // Import the bell icon
// import { RxCross1 } from "react-icons/rx";
// // import brand_assure_logo from '../assets/brand_assure_login.png';
// import brandAsureLogo from '../assets/brand_assure_logo.svg';
// import MyProfile from './MyProfile';
// import ChangeDatabase from './ChangeDatabase';

// function Header({ toggleSidebar, setActiveButton }) {
//   const [showDropdown, setShowDropdown] = useState(false);
//   const [showProfile, setShowProfile] = useState(false);
//   const [showDatabaseModal, setShowDatabaseModal] = useState(false);
//   const [userName, setUserName] = useState('');
//   const [db_count, setDB_Count] = useState(null);
//   const [databaseName, setDatabaseName] = useState(''); // New state for database name
//   const navigate = useNavigate();
//   const headerRef = useRef(null);
//   const timeoutRef = useRef(null); // Add useRef to track the timeout
//   const userId = localStorage.getItem('userId');
//   const [showNotifications, setShowNotifications] = useState(false); // State for bell notifications
//   const [pendingApprovalsCount, setPendingApprovalsCount] = useState(null)
//   const notificationRef = useRef(null); // Ref for the notification dropdown
//   const [remainingDocs, setRemainingDocs] = useState(null); // Track remaining documents
//   const [showSubscriptionWarning, setShowSubscriptionWarning] = useState(true);
//   const [subscriptionMessage, setSubscriptionMessage] = useState("");



//   useEffect(() => {
//     fetchRemainingDocuments();
//   }, []);

//   const fetchRemainingDocuments = async () => {
//     try {
//       const response = await fetch('/mcv/subscription_expiration_status'); 
//       const data = await response.json();
  
//       if (data.status === 'SUCCESS') {
//         setSubscriptionMessage(data.subscription_message);
//       } else {
//         console.error('Failed to fetch subscription status:', data.subscription_message);
//         setSubscriptionMessage("Error fetching subscription status");
//       }
//     } catch (error) {
//       console.error('Error fetching subscription status:', error);
//       setSubscriptionMessage("Error fetching subscription status");
//     }
//   };

//   // Function to retrieve user data, database count, and database name
//   const retrieveUserData = () => {
//     const userData = JSON.parse(localStorage.getItem('userData'));
//     // const databaseCount = localStorage.getItem('databaseCount');
//     // const userDbDefault = localStorage.getItem('userDbDefault');

//     if (userData) {
//       setUserName(userData[1] || '');
//     }

//     // if (databaseCount) {
//     //   setDB_Count(parseInt(databaseCount, 10));
//     // }

//     // if (userDbDefault === 'mutual_fund') {
//     //   setDatabaseName('Mutual Fund');
//     // } else if (userDbDefault === 'insurance') {
//     //   setDatabaseName('Insurance');
//     // }

//     console.log("The stored user name is:", userData ? userData[1] : "No user data");
//     // console.log("The database count is:", databaseCount);
//     console.log("The database name is:", databaseName);
//   };

//   useEffect(() => {
//     // Retrieve user details and set state
//     retrieveUserData();
//     fetchAllPendingApprovals();

//     // Handle auto logout logic
//     const logoutExpiration = localStorage.getItem("logoutExpiration");
//     const currentTime = Date.now();

//     if (logoutExpiration) {
//       const remainingTime = parseInt(logoutExpiration, 10) - currentTime;
//       if (remainingTime <= 0) {
//         handleLogout(); // Logout immediately if timeout has expired
//       } else {
//         const timeoutId = setTimeout(() => {
//           handleLogout();
//         }, remainingTime);

//         return () => clearTimeout(timeoutId); // Cleanup timeout on unmount
//       }
//     }
//   }, []);


//   const handleUserIconClick = () => {
//     setShowDropdown(!showDropdown);
//   };

//   const handleBellClick = () => {
//     setShowNotifications(!showNotifications);
//   };

//   const handleNotificationClickOutside = (event) => {
//     if (
//       notificationRef.current &&
//       !notificationRef.current.contains(event.target) &&
//       event.target !== document.querySelector('.header__bell-icon')
//     ) {
//       setShowNotifications(false);
//     }
//   };

//   useEffect(() => {
//     if (showNotifications) {
//       document.addEventListener('mousedown', handleNotificationClickOutside);
//     } else {
//       document.removeEventListener('mousedown', handleNotificationClickOutside);
//     }
//     return () => {
//       document.removeEventListener('mousedown', handleNotificationClickOutside);
//     };
//   }, [showNotifications]);
  

//   const fetchAllPendingApprovals = async () => {
//     try {
//       const response = await fetch(`/mcv/list_pending_approvals`);
//       const data = await response.json();
//       if (data.body.status === 'SUCCESS') {
//         setPendingApprovalsCount(data.body.data.length); // Update notification count
//       } else {
//         console.error('Failed to fetch pending approvals:', data.body.data);
//       }
//     } catch (error) {
//       console.error('Error fetching pending approvals:', error);
//     }
//   };

//   const handleLogout = () => {
//     fetch('/mcv/logout', {
//       method: 'GET',
//       credentials: 'include',
//     })
//       .then((response) => {
//         if (response.ok) {
//           localStorage.removeItem('userId');
//           localStorage.removeItem('userData');
//           // localStorage.removeItem('databaseCount');
//           localStorage.removeItem('userDbDefault');
//           localStorage.removeItem('activeButton');
//           localStorage.removeItem('isValidateOpen');
//           localStorage.removeItem('isManageOpen');
//           localStorage.removeItem('logoutExpiration');
//           navigate(`/mcv/login`);
//         } else {
//           console.error('Logout failed:', response);
//         }
//       })
//       .catch((error) => {
//         console.error('There was an error logging out', error);
//       });
//   };

//   const handleProfile = () => {
//     setShowProfile(true);
//     setShowDropdown(false);
//   };

//   const handleSwitchDatabase = () => {
//     setShowDatabaseModal(true);
//     setShowDropdown(false);
//   };

//   const handleClickOutside = (event) => {
//     if (headerRef.current && !headerRef.current.contains(event.target)) {
//       setShowDropdown(false);
//     }
//   };

//   useEffect(() => {
//     document.addEventListener('mousedown', handleClickOutside);
//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside);
//     };
//   }, []);

//   return (
//     <header className="header" ref={headerRef}>
//       <div className='brand-assure-logo-and-multip-selection-icon'>
//         <div className="header__menu-icon" onClick={toggleSidebar}>☰</div>
//           <img src={brandAsureLogo} alt="BrandAssure" className="brand-assure-icon" />
//       </div>
//       <div className="header__title-section">

//         {subscriptionMessage === "Your subscription is about to end" && 
//         showSubscriptionWarning && 
//         (
//           <div className="header__usage-status clickable">
//             <span onClick={() => navigate('/mcv/subscriptions')}>{subscriptionMessage}</span>
//             <button className="header-subscription-close" onClick={() => setShowSubscriptionWarning(false)}><RxCross1 /></button>
//           </div>
//         )}
        
//         {subscriptionMessage === "Your subscription has expired" && (
//           <div className="header__usage-status clickable" onClick={() => navigate('/mcv/subscriptions')}>{subscriptionMessage}</div>
//         )}

//       </div>

//       <div className="header__icons">
//         <div className="header__bell-icon" onClick={handleBellClick}>
//           <HiBellAlert className="bell-icon" />
//           {pendingApprovalsCount > 0 && (
//             <span className="notification-count">{pendingApprovalsCount}</span>
//           )}
//         </div>
//         {showNotifications && (
//           // <div ref={notificationRef} className="notifications-dropdown">
//           //   <p>You have {pendingApprovalsCount>0 ? pendingApprovalsCount : 0} pending approvals</p>
//           // </div>

//           <div
//   ref={notificationRef}
//   className="notifications-dropdown"
//   onClick={() => {
//     setShowNotifications(false); // Close dropdown
//     setActiveButton('/mcv/pending-approvals'); // Update sidebar active state
//     navigate('/mcv/pending-approvals'); // Navigate
//   }}
// >
//   <p>You have {pendingApprovalsCount > 0 ? pendingApprovalsCount : 0} pending approvals</p>
// </div>


          
//         )}
//         <div className="header__user-icon" onClick={handleUserIconClick}>
//           Hi {userName} <MdPerson className="user-icon" />
//         </div>
//       </div>
//       {showDropdown && (
//         <div className="header__dropdown">
//           <button className="header__dropdown-button" onClick={handleProfile}>
//             <FaUserCircle className="dropdown-icon" />
//             My Profile
//           </button>
//           {/* {db_count === 3 && ( // Conditionally render the Switch Database button based on count
//             <button className="header__dropdown-button" onClick={handleSwitchDatabase}>
//               <LuDatabaseBackup className="dropdown-icon" />
//               Switch Domain
//             </button>
//           )} */}
//           <button className="header__dropdown-button" onClick={handleLogout}>
//             <FiLogOut className="dropdown-icon" />
//             Logout
//           </button>
//         </div>
//       )}
//       {showProfile && <MyProfile userId={userId} onClose={() => setShowProfile(false)} />}
//       {/* {showDatabaseModal && <ChangeDatabase onClose={() => setShowDatabaseModal(false)} />} */}
//     </header>
//   );
// }

// export default Header;













//Above solution is for pending approval redirect logic but commented due to multiple API calling at a time


















import React, { useState, useEffect, useRef } from 'react';
import './Header.css';
import { useNavigate } from 'react-router-dom';
import { MdPerson } from 'react-icons/md';
import { FaUserCircle } from 'react-icons/fa';
import { FiLogOut } from 'react-icons/fi';
import { LuDatabaseBackup } from "react-icons/lu";
import { HiBellAlert } from "react-icons/hi2"; // Import the bell icon
import { RxCross1 } from "react-icons/rx";
// import brand_assure_logo from '../assets/brand_assure_login.png';
import brandAsureLogo from '../assets/brand_assure_logo.svg';
import MyProfile from './MyProfile';
import ChangeDatabase from './ChangeDatabase';

function Header({ toggleSidebar }) {
  const [showDropdown, setShowDropdown] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const [showDatabaseModal, setShowDatabaseModal] = useState(false);
  const [userName, setUserName] = useState('');
  const [db_count, setDB_Count] = useState(null);
  const [databaseName, setDatabaseName] = useState(''); // New state for database name
  const navigate = useNavigate();
  const headerRef = useRef(null);
  const timeoutRef = useRef(null); // Add useRef to track the timeout
  const userId = localStorage.getItem('userId');
  const [showNotifications, setShowNotifications] = useState(false); // State for bell notifications
  const [pendingApprovalsCount, setPendingApprovalsCount] = useState(null)
  const notificationRef = useRef(null); // Ref for the notification dropdown
  const [remainingDocs, setRemainingDocs] = useState(null); // Track remaining documents
  const [showSubscriptionWarning, setShowSubscriptionWarning] = useState(true);
  const [subscriptionMessage, setSubscriptionMessage] = useState("");
  const [userRole, setUserRole] = useState(null);


  const roles = {
    OWNER: 'Owner',
    SUPERADMIN: 'SuperAdmin',
    ADMIN: 'Admin',
    WRITE: 'Write',
    READ: 'Read',
  };


  useEffect(() => {

    const userData = JSON.parse(localStorage.getItem('userData'));
    const role = userData?.[6];
    if (userData?.[6]) {
      setUserRole(userData[6]);
    }

    fetchRemainingDocuments();
  }, []);

  const fetchRemainingDocuments = async () => {
    try {
      const response = await fetch('/mcv/subscription_expiration_status'); 
      const data = await response.json();
  
      if (data.status === 'SUCCESS') {
        setSubscriptionMessage(data.subscription_message);
      } else if (data.status === 'FAILED') {
        setSubscriptionMessage(data.subscription_message);
      } else {
        console.error('Failed to fetch subscription status:', data.subscription_message);
        setSubscriptionMessage("Error fetching subscription status");
      }
    } catch (error) {
      console.error('Error fetching subscription status:', error);
      setSubscriptionMessage("Error fetching subscription status");
    }
  };

  // Function to retrieve user data, database count, and database name
  const retrieveUserData = () => {
    const userData = JSON.parse(localStorage.getItem('userData'));
    // const databaseCount = localStorage.getItem('databaseCount');
    // const userDbDefault = localStorage.getItem('userDbDefault');

    if (userData) {
      setUserName(userData[1] || '');
    }

    // if (databaseCount) {
    //   setDB_Count(parseInt(databaseCount, 10));
    // }

    // if (userDbDefault === 'mutual_fund') {
    //   setDatabaseName('Mutual Fund');
    // } else if (userDbDefault === 'insurance') {
    //   setDatabaseName('Insurance');
    // }

    console.log("The stored user name is:", userData ? userData[1] : "No user data");
    // console.log("The database count is:", databaseCount);
    console.log("The database name is:", databaseName);
  };

  useEffect(() => {
    // Retrieve user details and set state
    retrieveUserData();

    // fetchAllPendingApprovals();
    const userData = JSON.parse(localStorage.getItem('userData'));
    const role = userData?.[6];

    if (role !== roles.READ && role !== roles.WRITE && role !== roles.ADMIN) {
      fetchAllPendingApprovals();
    }

    // Handle auto logout logic
    const logoutExpiration = localStorage.getItem("logoutExpiration");
    const currentTime = Date.now();

    if (logoutExpiration) {
      const remainingTime = parseInt(logoutExpiration, 10) - currentTime;
      if (remainingTime <= 0) {
        handleLogout(); // Logout immediately if timeout has expired
      } else {
        const timeoutId = setTimeout(() => {
          handleLogout();
        }, remainingTime);

        return () => clearTimeout(timeoutId); // Cleanup timeout on unmount
      }
    }
  }, []);


  const handleUserIconClick = () => {
    setShowDropdown(!showDropdown);
  };

  const handleBellClick = () => {
    setShowNotifications(!showNotifications);
  };

  const handleNotificationClickOutside = (event) => {
    if (
      notificationRef.current &&
      !notificationRef.current.contains(event.target) &&
      event.target !== document.querySelector('.header__bell-icon')
    ) {
      setShowNotifications(false);
    }
  };

  useEffect(() => {
    if (showNotifications) {
      document.addEventListener('mousedown', handleNotificationClickOutside);
    } else {
      document.removeEventListener('mousedown', handleNotificationClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleNotificationClickOutside);
    };
  }, [showNotifications]);
  

  const fetchAllPendingApprovals = async () => {
    try {
      const response = await fetch(`/mcv/list_pending_approvals`);

      // Handle unauthorized (403) first
      if (response.status === 403) {
        const data = await response.json();
        alert(data.detail?.data || "Access denied.");
        // onClose();
        return;
      }
      
      const data = await response.json();
      if (data.body.status === 'SUCCESS') {
        setPendingApprovalsCount(data.body.data.length); // Update notification count
      } else {
        console.error('Failed to fetch pending approvals:', data.body.data);
      }
    } catch (error) {
      console.error('Error fetching pending approvals:', error);
    }
  };

  const handleLogout = () => {
    fetch('/mcv/logout', {
      method: 'GET',
      credentials: 'include',
    })
      .then((response) => {
        if (response.ok) {
          localStorage.removeItem('userId');
          localStorage.removeItem('userData');
          // localStorage.removeItem('databaseCount');
          localStorage.removeItem('userDbDefault');
          localStorage.removeItem('activeButton');
          localStorage.removeItem('isValidateOpen');
          localStorage.removeItem('isManageOpen');
          localStorage.removeItem('logoutExpiration');
          navigate(`/mcv/login`);
        } else {
          console.error('Logout failed:', response);
        }
      })
      .catch((error) => {
        console.error('There was an error logging out', error);
      });
  };

  const handleProfile = () => {
    setShowProfile(true);
    setShowDropdown(false);
  };

  const handleSwitchDatabase = () => {
    setShowDatabaseModal(true);
    setShowDropdown(false);
  };

  const handleClickOutside = (event) => {
    if (headerRef.current && !headerRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <header className="header" ref={headerRef}>
      <div className='brand-assure-logo-and-multip-selection-icon'>
        <div className="header__menu-icon" onClick={toggleSidebar}>☰</div>
          <img src={brandAsureLogo} alt="BrandAssure" className="brand-assure-icon" />
      </div>
      <div className="header__title-section">

        {subscriptionMessage === "Your subscription is about to end" && 
        showSubscriptionWarning && 
        (
          <div className="header__usage-status clickable">
            <span onClick={() => navigate('/mcv/subscriptions')}>{subscriptionMessage}</span>
            <button className="header-subscription-close" onClick={() => setShowSubscriptionWarning(false)}><RxCross1 /></button>
          </div>
        )}
        
        {subscriptionMessage === "Your subscription has expired" && (
          <div className="header__usage-status clickable" onClick={() => navigate('/mcv/subscriptions')}>{subscriptionMessage}</div>
        )}

        {subscriptionMessage === "No active or pending subscription found" && (
          <div className="header__usage-status clickable" onClick={() => navigate('/mcv/subscriptions')}>{subscriptionMessage}</div>
        )}

      </div>

      <div className="header__icons">
        {(userRole !== roles.READ && userRole !== roles.WRITE && userRole !== roles.ADMIN) && (
          <>
            <div className="header__bell-icon" onClick={handleBellClick}>
              <HiBellAlert className="bell-icon" />
              {pendingApprovalsCount > 0 && (
                <span className="notification-count">{pendingApprovalsCount}</span>
              )}
            </div>
            {showNotifications && (
              <div ref={notificationRef} className="notifications-dropdown">
                <p>You have {pendingApprovalsCount>0 ? pendingApprovalsCount : 0} pending approvals</p>
              </div>
            )}
          </>
        )}
        <div className="header__user-icon" onClick={handleUserIconClick}>
          Hi {userName} <MdPerson className="user-icon" />
        </div>
      </div>
      {showDropdown && (
        <div className="header__dropdown">
          <button className="header__dropdown-button" onClick={handleProfile}>
            <FaUserCircle className="dropdown-icon" />
            My Profile
          </button>
          {/* {db_count === 3 && ( // Conditionally render the Switch Database button based on count
            <button className="header__dropdown-button" onClick={handleSwitchDatabase}>
              <LuDatabaseBackup className="dropdown-icon" />
              Switch Domain
            </button>
          )} */}
          <button className="header__dropdown-button" onClick={handleLogout}>
            <FiLogOut className="dropdown-icon" />
            Logout
          </button>
        </div>
      )}
      {showProfile && <MyProfile userId={userId} onClose={() => setShowProfile(false)} />}
      {/* {showDatabaseModal && <ChangeDatabase onClose={() => setShowDatabaseModal(false)} />} */}
    </header>
  );
}

export default Header;


